/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, IconButton, Tooltip, useTheme } from "@mui/material";
import { stackCenterGap } from "../../../../styles/utilStyles";
import { Info, Replay } from "@mui/icons-material";
import { tokens } from "../../../../theme";
import { buildDetailedPanelStyles } from "../../styles";
import { permissionListIncludes } from "../../../../utils/helperFunctions";

const StepBox = ({ step, id, showRetryDialog, retryPermissionList }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  return (
    <Box sx={buildDetailedPanelStyles.stepMainBox(colors)}>
      <Typography
        variant="h5"
        sx={buildDetailedPanelStyles.stepName(colors, step?.status)}
      >
        {step?.stepName}
      </Typography>

      {step?.status === "FAILED" ? (
        <Tooltip title={<Typography variant="body2">{step?.error}</Typography>}>
          <Info sx={buildDetailedPanelStyles.stepErrorIcon(colors)} flex="1" />
        </Tooltip>
      ) : (
        <></>
      )}
      <Box sx={stackCenterGap} />
      {permissionListIncludes(retryPermissionList, id) ? (
        <IconButton
          sx={buildDetailedPanelStyles.retryIcon}
          flex="1"
          onClick={() => {
            showRetryDialog(
              `Retry workflow from step ${step?.stepName} onwards`,
              { stepName: step?.stepName },
              id
            );
          }}
        >
          <Replay />
        </IconButton>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default StepBox;
